import { API } from "./utils"

export const reporting = {
  matchingStatistics: (params = null) => API.get("/reporting/matching-statistics/", { params }),
  matchingStatisticsExport: data => API.post("/reporting/matching-statistics/export/", data)
}
